import httpRequest from "../../../axios/index";
import { ADMIN_JOBHISTORY } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllJobs = async (
  setLoading,
  SetAllData,
  type = "",
  Search = "",
  Date = "",
  page = 1
) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();
    if (type) {
      const correctedType =
        type === "On-Going" ? "ongoing" : type.toLowerCase();
      params.append("type", correctedType);
    }

    if (Search) {
      params.append("search", Search);
    }
    if (Date) {
      params.append("date", Date);
    }
    if (page) {
      params.append("page", page);
    }
    let url = `${ADMIN_JOBHISTORY}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(url);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export { GetAllJobs };
